import { BlockOverrides } from 'baseui/block';
import { THEME } from '../../../../../utils/theme/index';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,

      [THEME.media.medium]: {
        marginTop: '-16px',
        justifyContent: 'center',
        textAlign: 'center',
      },
    },
  },
};

export const CENTER_BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'flex',
      width: '100%',
      marginBottom: 0,
      marginTop: '-16px',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
};

export const TEXT: BlockOverrides = {
  Block: {
    style: {
      width: '65%',
      textAlign: 'left',
      lineHeight: 1.5,
      whiteSpace: 'pre-line',

      [THEME.media.xlarge]: {
        fontSize: '18px',
      },

      [THEME.media.large]: {
        fontSize: '16px',
      },

      [THEME.media.medium]: {
        fontSize: '20px',
        textAlign: 'center',
        width: '90%',
        marginTop: 0,
      },

      [THEME.media.small]: {
        fontSize: '12px',
      },
    },
  },
};

export const CENTER_TEXT: BlockOverrides = {
  Block: {
    style: {
      lineHeight: 1.5,
      whiteSpace: 'pre-line',
      textAlign: 'center',
      width: '90%',
      marginTop: 0,

      [THEME.media.xlarge]: {
        fontSize: '18px',
      },

      [THEME.media.large]: {
        fontSize: '16px',
      },

      [THEME.media.medium]: {
        fontSize: '20px',
      },

      [THEME.media.small]: {
        fontSize: '12px',
      },
    },
  },
};
